/** Numeric wire values — mirrors EPN.Accounting.Api's own `GlCategory` enum exactly (no
 * JsonStringEnumConverter anywhere in EPN, see docs/staging-data.md). Deliberately capped at 8 members —
 * see docs/accounting-architecture.md for the full granularity-gap statement against legacy. */
export const GlCategory = {
  WageExpense: 1,
  EmployerTaxExpense: 2,
  EmployeeTaxWithholdingPayable: 3,
  EmployerTaxLiabilityPayable: 4,
  PreTaxDeductionPayable: 5,
  PostTaxDeductionPayable: 6,
  GarnishmentPayable: 7,
  NetPayPayable: 8,
} as const;

export const ALL_GL_CATEGORIES = Object.values(GlCategory);

export const glCategoryLabels: Record<number, string> = {
  1: 'Wage Expense',
  2: 'Employer Tax Expense',
  3: 'Employee Tax Withholding Payable',
  4: 'Employer Tax Liability Payable',
  5: 'Pre-Tax Deduction Payable',
  6: 'Post-Tax Deduction Payable',
  7: 'Garnishment Payable',
  8: 'Net Pay Payable',
};

export interface GlMappingResponse {
  category: number;
  glAccountCode: string;
  glAccountName: string;
  updatedAtUtc: string;
  updatedByUserId: string;
  updatedByEmailSnapshot: string;
}

export interface GlMappingLineInput {
  category: number;
  glAccountCode: string;
  glAccountName: string;
}

export interface GlExportLineResponse {
  category: number;
  glAccountCode: string;
  glAccountName: string;
  isDebit: boolean;
  amount: number;
  description: string;
}

export interface GlExportResponse {
  id: string;
  companyId: string;
  payrollRunId: string;
  checkDate: string;
  totalDebits: number;
  totalCredits: number;
  providerVoucherId: string | null;
  lines: GlExportLineResponse[];
  exportedByUserId: string;
  exportedByEmailSnapshot: string;
  exportedAtUtc: string;
}

/** `status` is the raw wire string ("Matched"/"Mismatched"/"PaymentNotYetSettled") — see
 * ReconciliationResponse's own doc comment on the API side for why this one status field is a
 * descriptive string rather than a numeric wire enum. */
export interface ReconciliationResponse {
  id: string;
  companyId: string;
  payrollRunId: string;
  glExportRecordId: string;
  expectedNetPayAmount: number;
  actualSettledAmount: number | null;
  status: string;
  varianceAmount: number | null;
  triggeredByUserId: string;
  triggeredByEmailSnapshot: string;
  createdAtUtc: string;
}

/** Trimmed to what this page needs from Module 7's own `PayrollRunResponse` — this module has no
 * dedicated frontend feature yet, so the GL export page reads it directly (see
 * HttpAccountingGateway's own doc comment). */
export interface PayrollRunSummary {
  id: string;
  status: string;
  checkDate: string;
  periodStartDate: string;
  periodEndDate: string;
}
